<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="viewRecord" />
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
// import Prospect from '@/js/prospect.js'
export default {
  name: 'Action',
  methods: {
    viewRecord () {
      this.$router.push(`./prospects/view/${this.params.data.id}`).catch(() => {})
    },
    editRecord () {
      this.$router.push(`./prospects/edit/${this.params.data.id}`).catch(() => {})
    }
  }
}
</script>
